export default __webpack_public_path__ + "static/media/gl.2466f7b0.svg";